<template lang="pug">

    div

        //- Navigation
        navigation

        //- Content
        form.ui.form(v-on:submit.prevent="submit()")

            //- Formulare
            create-form(
                ref="createForm"
                v-bind:company-models='companyModels'
                v-bind:country-models='countryModels'
                v-on:cancel="cancel"
            )

</template>

<script>
    import store from '@/store'
    import CreateForm from '@/components/addresses/CreateForm'
    import Navigation from '@/components/addresses/Navigation'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {

        async beforeRouteEnter(from, to, next) {
            await Promise.all([

                // Alle Unternehmen laden (für das Unternehmen-Dropdown)
                store.dispatch('companies/loadAll'),

                // Laender laden
                store.dispatch('countries/loadAll'),

            ])

            next()
        },

        components: { CreateForm, Navigation },

        computed: {

            companyModels() {
                return this.$store.getters['companies/all']
            },

            countryModels() {
                return this.$store.getters['countries/all']
            }

        },

        methods: {

            cancel() {
                this.$router.push({ name: 'addresses' })
            },

            async persist() {
                try {
                    // Speichern
                    await this.$refs.createForm.persist()

                    // Erfolgsnachricht anzeigen
                    this.$growl.success('Adresse wurde gespeichert')

                    // Weiterleitung
                    this.$router.push({ name: 'addresses' })

                } catch (e) {
                    // Fehlermeldung anzeigen
                    this.$growl.fatal('Adresse konnte nicht gespeichert werden.', e)
                }
            },

            async submit() {
                // Validierung
                if (await this.$refs.createForm.validate()) {
                    this.persist()
                } else {
                    this.$scrollToErrorAndFocus()
                }
            }

        }

    }

</script>
